<template>
    <div class="field" style="padding-right: 15px;">
        <a class="button is-danger is-outlined  is-small"
           v-bind:class="{ 'is-loading': isLoading }"
           @click.prevent="bidCancel()">
            <span class="icon is-small">
                <i class="far fa-trash-alt"></i>
            </span>
            Cancel Bid
        </a>
    </div>
</template>

<script>
    import apiBids from '../../../../api/apiBids'
    export default {
        props: ['bid'],
        data() {
            return {
                isLoading: false,
                currentBid: {
                    id: this.bid.bids[0].id,
                    status: this.$bidStatusCancel
                }
            }
        },
        methods: {
            bidCancel() {
                this.isLoading = true
                apiBids
                    .updateBidRequest(this.currentBid)
                    .then((response) => {
                        this.isLoading = false
                        this.bid.bids[0].status = this.$bidStatusCancel
                    })
                    .catch((err) => {
                        console.log(err)
                        this.isLoading = false
                    })
            }
        }
    }

</script>

<style scoped>
    .button {
        font-weight: 700;
    }
    .button .icon:first-child:last-child {
        margin-right: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/Card/Buttons/Lots/BidCancel.vue